module.exports = __webpack_public_path__ + "static/media/doctorLogo.6b97c507.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/doctorLogo.png
// module id = 455
// module chunks = 5